var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dk0ordui7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9",
    style: {
      fill: "#fff"
    },
    d: "M0 0h24.285v22.768H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4",
    style: {
      clipPath: "url(#dk0ordui7a)"
    },
    transform: "translate(6 7)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M4.693 22.347a2.322 2.322 0 0 1-1.665-.653 2.4 2.4 0 0 1-.628-2.086 3.862 3.862 0 0 1 1.121-2.153l4.914-4.913a.5.5 0 0 1 .708 0l3.031 3.032a.5.5 0 0 1 0 .707l-4.911 4.912a3.715 3.715 0 0 1-2.57 1.154m4.1-8.744-4.562 4.559a2.861 2.861 0 0 0-.838 1.586 1.422 1.422 0 0 0 .342 1.239 1.331 1.331 0 0 0 .958.36 2.75 2.75 0 0 0 1.862-.861l4.561-4.559z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M21.109 5.536a1.91 1.91 0 0 1-1.361-.564 1.931 1.931 0 0 1 0-2.723L21.415.582a.5.5 0 0 1 .708 0L24.138 2.6a.5.5 0 0 1 0 .707L22.47 4.972a1.911 1.911 0 0 1-1.361.564m.66-3.894-1.314 1.315a.928.928 0 0 0 0 1.309.947.947 0 0 0 1.307 0l1.315-1.314z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M14.6 10.614a.5.5 0 0 1-.354-.854l5.5-5.5a.5.5 0 1 1 .708.707l-5.5 5.5a.5.5 0 0 1-.354.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M19.415 22.767a3.331 3.331 0 0 1-2.368-.979L7.3 12.034A6.074 6.074 0 0 1 .385 3.947a.5.5 0 0 1 .822-.179l2.9 2.9 2.021-.542.54-2.019-2.9-2.9a.5.5 0 0 1 .178-.821A6.1 6.1 0 0 1 6.085 0a6.025 6.025 0 0 1 4.294 1.778A6.11 6.11 0 0 1 12.031 7.3l9.754 9.753a3.35 3.35 0 0 1-2.37 5.718M7.453 10.985a.5.5 0 0 1 .354.146l9.947 9.95a2.351 2.351 0 0 0 3.324-3.325l-9.949-9.949A.5.5 0 0 1 11 7.331a5.039 5.039 0 0 0-1.328-4.846A5.115 5.115 0 0 0 5.074 1.1l2.5 2.5a.5.5 0 0 1 .129.483l-.687 2.58a.5.5 0 0 1-.354.354l-2.578.691a.5.5 0 0 1-.484-.129l-2.5-2.5A5.073 5.073 0 0 0 7.33 11a.517.517 0 0 1 .123-.015",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M19.269 18.366a.834.834 0 1 0 .834.834.833.833 0 0 0-.834-.834",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpo);
export default __webpack_public_path__ + "static/media/cpo.5c813d40ef7681bb855901d9330067df.svg";
export { ForwardRef as ReactComponent };